import { render, staticRenderFns } from "./honorcategorydetails.vue?vue&type=template&id=47e3e431&scoped=true&"
import script from "./honorcategorydetails.vue?vue&type=script&lang=js&"
export * from "./honorcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./honorcategorydetails.vue?vue&type=style&index=0&id=47e3e431&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3e431",
  null
  
)

export default component.exports